// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Heading.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Heading.tsx");
  import.meta.hot.lastModified = "1740183864611.5652";
}
// REMIX HMR END

import clsx from "clsx";
/**
 * Renders a Heading using the specified tag.
 *
 * @param tag The tag to render.
 * @param className Tailwind classes to add custom styles.
 * @returns A styled Heading element.
 *
 */

export default function HeadingElement({
  tag,
  className,
  id,
  children
}) {
  const Component = tag;
  const baseStyles = {
    h1: "font-bold text-[28px] md:text-[30px] lg:text-3xl",
    h2: "font-bold text-[21px] md:text-[22px] lg:text-2xl",
    h3: "font-semibold text-[18px] md:text-[19px] lg:text-xl"
  };
  return <Component id={id} className={clsx(baseStyles[tag], "text-primary-700 mb-4", className)}>{children}</Component>;
}
_c = HeadingElement;
var _c;
$RefreshReg$(_c, "HeadingElement");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;